import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 2, placeholder = "N/D") {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return placeholder;
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

// Formato único de los importes de PROYECCIÓN en toda la app (0 decimales,
// nulos como "—"). Una sola definición: cuando el criterio cambie (Loom del
// cliente), se cambia aquí y las 7 vistas que antes duplicaban el formateador
// cambian a la vez. Históricos y proyectados comparten SIEMPRE este formato
// dentro de las tablas de proyección.
export function formatEur(value) {
  return formatCurrency(value, 0, "—");
}

export function formatPercent(value, decimals = 2) {
  if (value === null || value === undefined) return "N/D";
  return new Intl.NumberFormat("es-ES", {
    style: "percent",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value / 100);
}

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined) return "N/D";
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function isProfit(value) {
  return value > 0;
}

/**
 * Extrae un mensaje de error legible de una respuesta axios.
 *
 * En las descargas (`responseType: "blob"`) el cuerpo de error llega como Blob,
 * no como JSON, así que `error.response.data.detail` es siempre `undefined`. Este
 * helper lee el Blob, parsea el JSON y devuelve el `detail` real del backend.
 * Si no hay respuesta (error de red / sesión caducada) o el parseo falla, cae al
 * `fallback`. Es async: usar `toast.error(await parseBlobError(e, "..."))`.
 */
export async function parseBlobError(error, fallback = "No se pudo completar la operación") {
  const data = error?.response?.data;
  try {
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const json = JSON.parse(text);
        return json.detail || json.message || fallback;
      } catch {
        return text?.trim() || fallback;
      }
    }
    if (data && typeof data === "object") return data.detail || data.message || fallback;
    if (typeof data === "string" && data.trim()) return data.trim();
  } catch {
    // Cualquier fallo leyendo el error → mensaje genérico.
  }
  if (error?.response?.status === 401) return "Tu sesión ha caducado. Vuelve a iniciar sesión.";
  return fallback;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
}
